import {
	mapGetters,
	mapActions
} from 'vuex';

import {
	isEmpty
} from 'lodash';

import toastr from '@/support/toastr';
import PageBar from '@/components/page-bar/page-bar';

import store from './../store';

import SchoolClass from '@/domains/school/class-list/main';
import Year from '@/components/calendar/year/main';
import Month from '@/components/calendar/month/main';
import Week from '@/components/calendar/week/main';

import {
	EventBus
} from '@/support/event-bus';

export default {
	...store,
	name: 'LessonPlanningReportPage',
	data: () => ({
		year: '',
		month: '',
		week: ''
	}),
	components: {
		PageBar,
		SchoolClass,
		Year,
		Month,
		Week
	},
	computed: {
		...mapGetters([
			'ENUM',
			'getLoggedUser',
			'currentYear',
			'currentMonth',
			'currentWeek',
			'getClass',
			'weeks'
		])
	},
	methods: {
		...mapActions([
			'setBreadcrumb',
			'putCurrentMonth',
			'putCurrentWeek',
			'putWeekList',
			'getLessonReport'
		]),
		updateMonth() {
			this.month = '';
			this.putCurrentMonth({});

			EventBus.$emit('updateWeekList', {
				year: this.year,
				month: this.month
			});
		},
		updateWeek() {
			this.week = '';
			this.putCurrentWeek({});

			EventBus.$emit('updateWeekList', {
				year: this.year,
				month: this.month
			});
		},
		dateDiff(input, value = moment(), units = 'days') {
			return moment(value).diff(input, units);
		},
		generateReport() {

			if (this.currentYear && this.currentMonth && !isEmpty(this.currentWeek) && this.getClass) {

				const queryFilter = {
					startDate: this.currentWeek.startDate,
					endDate: this.currentWeek.endDate,
					schoolClassId: this.getClass.schoolClassId
				};

				return this.getLessonReport({
					userId: this.getLoggedUser.id,
					filter: queryFilter
				}).then(() => {

				});
			}
		},
	},
	created() {

		this.setBreadcrumb([{
			text: this.$gettext('Relatórios')
		}, {
			text: this.$gettext('Planejamento de aula')
		}]);

	},
	mounted() {

		this.year = this.currentYear;
		this.month = this.currentMonth;
		this.week = this.currentWeek;
		this.schoolClass = this.schoolClass;

		EventBus.$on('yearChanged', (payload) => {
			this.year = payload;

			this.updateMonth();
			this.updateWeek();
		});

		EventBus.$on('monthChanged', (payload) => {
			this.month = payload;

			this.updateWeek();
		});

		EventBus.$on('weekChanged', (payload) => {
			this.week = payload;
		});

		EventBus.$on('classChanged', () => {
			this.generateReport();
		});

	},
	beforeDestroy() {
		EventBus.$off('classChanged');
		EventBus.$off('yearChanged');
		EventBus.$off('monthChanged');
		EventBus.$off('weekChanged');
	}
};



// WEBPACK FOOTER //
// ./sources/app/lesson-planning/report/index.js